<template>
	<v-layout>
		<v-flex sm12 md6>
			<v-layout row wrap>
				<v-flex xs12 class="pa-1">
					<p class="add-event-step-header mb-0">Photos</p>
					<p class="add-event-step-sub-header">Events and experiences with at least 3 pictures get a better response! Pictures of the event space are good; candid pictures that show people interacting in the space are even better!</p>
					<p class="text-xs-center" style="font-size: 1em; color: #888;">Drop or click below to upload images</p>
					<vue-dropzone
						ref="imageDropzone"
						id="dropzone"
						:options="dropzoneOptions"
						v-on:vdropzone-removed-file="removeFile"
						v-on:vdropzone-success="uploadSuccess"
						v-on:vdropzone-queue-complete="uploadComplete"
						v-on:vdropzone-sending="uploadStarted"
					></vue-dropzone>
					<p class="add-event-step-secondary-header mt-4 mb-1">Set your cover image</p>
					<p class="add-event-step-sub-header">This is the picture that will appear in event listings, and will be the first thing people see on your event page.</p>
					<v-select
						color="link"
						avatar
						v-model="primaryImage"
						label="Primary Image"
						hide-details
						item-text="name"
						item-value="pk"
						item-avatar="image"
						:items="images"
						style="z-index:22!important; margin-bottom: 150px;"
						:menu-props="{maxHeight:'300'}"
					>
						<template slot="selection" slot-scope="data">
							<div class="pa-1">
								<v-avatar class="mr-3" size="32">
									<img :src="data.item.image">
								</v-avatar>
								{{ data.item.name }}
							</div>
						</template>
						<template slot="item" slot-scope="data">
							<template v-if="typeof data.item !== 'object'">
								<v-list-tile-content v-text="data.name"></v-list-tile-content>
							</template>
							<template v-else>
								<v-list-tile-avatar>
									<img v-bind:src="data.item.image"/>
								</v-list-tile-avatar>
								<v-list-tile-content>
									<v-list-tile-title v-html="data.item.name"></v-list-tile-title>
								</v-list-tile-content>
							</template>
						</template>
					</v-select>
				</v-flex>
			</v-layout>
		</v-flex>
		<v-flex xs12 md4 offset-md1 hidden-sm-and-down class="pt-3">
			<v-card class="add-event-tip-box">
				<v-card-text class="p-relative pt-5">
					<div class="info-trapezoid p-absolute">
						<div class="info-content">
							<img src="/static/images/icon/light-bulb-gray.svg" width="40" />
						</div>
					</div>
					<p class="add-event-tip-title">Your picture’s worth a thousand words!</p>
					<p class="add-event-tip-content">If possible, we recommend photos from previous events where people are actively using the space (note: pictures of people at a dinner party might not match this event you are planning).</p>
					<p class="add-event-tip-title">Don’t have good pictures?</p>
					<p class="add-event-tip-content">Not to worry! Just upload the best pictures of the space you can find, and we’ll find a few temporary pics we have that will match the look and feel your guests can expect.</p>
					<p class="add-event-tip-content">Then, when your event is underway, you can take new pictures that will be perfect for you next event.</p>
					<p class="add-event-tip-content">Whenever possible, we’ll even send someone to take professional pics of your event for you, so you just enjoy hosting.</p>
				</v-card-text>
			</v-card>
		</v-flex>
		<v-dialog scrollable v-model="infoDialog">
			<v-card style="width: 100%">
				<v-card-title class="mb-0 pb-2 pt-3">
					<img class="info-mobile-icon" src="/static/images/icon/light-bulb-gray.svg" />
				</v-card-title>
				<v-card-text style="max-height:50vh;">
					<p class="add-event-tip-title">Your picture’s worth a thousand words!</p>
					<p class="add-event-tip-content">If possible, we recommend photos from previous events where people are actively using the space (note: pictures of people at a dinner party might not match this event you are planning).</p>
					<p class="add-event-tip-title">Don’t have good pictures?</p>
					<p class="add-event-tip-content">Not to worry! Just upload the best pictures of the space you can find, and we’ll find a few temporary pics we have that will match the look and feel your guests can expect.</p>
					<p class="add-event-tip-content">Then, when your event is underway, you can take new pictures that will be perfect for you next event.</p>
					<p class="add-event-tip-content">Whenever possible, we’ll even send someone to take professional pics of your event for you, so you just enjoy hosting.</p>
				</v-card-text>
				<v-card-actions>
					<v-spacer>
					</v-spacer>
					<v-btn icon class="info-mobile-dialog-close-button" @click="infoDialog=false"><v-icon>close</v-icon></v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</v-layout>
</template>

<script>
import * as Cookies from 'js-cookie'
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.css'
import * as TYPES from '~/store/util/types'
import { deepCloneArray } from '~/utils/helper'

import { mapGetters, mapActions } from 'vuex'
export default {
	data() {
		return {
			photosUploading: false,
			removingImage: false,
			images: [],
			leaving: false, // To stop the removeFile method firing on page leave
			dropzoneOptions: {
				paramName: 'image',
				url: process.env.VUE_APP_SERVER_PROTOCOL + process.env.VUE_APP_SERVER_URL + 'api/v1/image-upload/',
				thumbnailWidth: 150,
				resizeMimeType: 'image/jpeg',
				resizeWidth: 1600,
				acceptedFiles: 'image/*',
				maxFilesize: 20,
				maxFiles: 25,
				duplicateCheck: true,
				addRemoveLinks: true,
				ignoreHiddenFiles: true,
				dictDefaultMessage: '<i style="font-size: 2.5em" class="fal fa-cloud-upload"></i>',
				headers: { Authorization: 'Bearer ' + this.$store.getters.getToken }
			}
		}
	},
	created() {
		this.images = deepCloneArray(this.getAddEventProp('imageObjs'))
		// this.images = .slice(0)
	},
	mounted() {
		let imageObjs = deepCloneArray(this.getAddEventProp('imageObjs'))
		let mockImage
		for (let i = 0; i < imageObjs.length; i++) {
			mockImage = {
				name: imageObjs[i].name,
				size: imageObjs[i].filesize,
				type: "image/*",
				pk: imageObjs[i].pk
			}
			if (imageObjs[i].locationImage) {
				mockImage['locationImage'] = true
			}
			this.$refs.imageDropzone.manuallyAddFile(mockImage, imageObjs[i].image)
		}
	},
	beforeRouteLeave(to, from, next) {
		this.leaving = true
		if (this.getAddEventProp('primaryImage') !== null) {
			if (this.getAddEventProp('images').length > 0) {
				let primaryInImages = false
				for (var i = 0; i < this.getAddEventProp('images').length; i++) {
					if (
						this.getAddEventProp('primaryImage') ===
						this.getAddEventProp('images')[i]
					) {
						primaryInImages = true
					}
				}
				if (primaryInImages === false) {
					this.setAddEventProp({ prop: 'primaryImage', value: null })
				}
			}
		}
		if (
			this.getAddEventProp('images').length > 0 &&
			this.getAddEventProp('primaryImage') !== null
		) {
			this.setAddEventValidStep(from.path)
			this.removeAddEventInvalidStep(from.path)
		} else {
			this.removeAddEventValidStep(from.path)
			this.setAddEventInvalidStep(from.path)
		}
		if (this.photosUploading) {
			this.setSnackbarText('Wait for photos to finish uploading')
			this.setSnackbarOpen(true)
			next(false)
		} else {
			next()
		}
	},
	methods: {
		...mapActions([
			'setAddEventImagesUrls',
			'addEventProcessFiles',
			'setAddEventProp',
			'setAddEventValidStep',
			'removeAddEventValidStep',
			'setAddEventInvalidStep',
			'removeAddEventInvalidStep',
			'serverRemoveImage',
			'setSnackbarOpen',
			'setSnackbarText'
		]),
		removeFile(image, message, xhr) {
			// Dev note :: This function is called both when the user removes/deletes an image, and when they leave the page
			console.log(image)
			let objIndex
			let data
			if (image.status === 'canceled') {
				return
			}
			if (image.hasOwnProperty('xhr')) {
				// If image was uploaded during the current page visit
				data = JSON.parse(image.xhr.response)
				let i = this.images.find(obj => {
					let data = JSON.parse(image.xhr.response)
					return obj.pk === data.pk
				})
				objIndex = this.images.indexOf(i)
			} else {
				// If the image was added from the browser localstorage (user left photos page and came back)
				data = image
				let i = this.images.find(obj => {
					return obj.pk === image.pk
				})
				objIndex = this.images.indexOf(i)
			}
			if (!this.leaving) {
				// If function was called from user deleting the image (not leaving the page)
				if (!data.locationImage) {
					this.serverRemoveImage(data.pk)
				}
				if (this.images.length > 1) {
					if (
						this.getAddEventProp('primaryImage') === this.images[objIndex].pk
					) {
						this.images.splice(objIndex, 1)
						this.setAddEventProp({
							prop: 'primaryImage',
							value: this.images[0].pk
						})
					} else {
						this.images.splice(objIndex, 1)
						this.setAddEventProp({ prop: 'primaryImage', value: null })
					}
				} else {
					this.images = []
					this.setAddEventProp({ prop: 'primaryImage', value: null })
				}
				this.setAddEventProp({
					prop: 'images',
					value: deepCloneArray(this.images.map(obj => obj.pk))
				})
				this.setAddEventProp({
					prop: 'imageObjs',
					value: deepCloneArray(this.images)
				})
			}
		},
		uploadSuccess(image, response) {
			if (
				this.getAddEventProp('primaryImage') === null ||
				this.getAddEventProp('images').length === 0
			) {
				this.setAddEventProp({ prop: 'primaryImage', value: response.pk })
			}

			this.images.push({
				name: response.filename,
				pk: response.pk,
				image: response.image,
				filesize: image.size
			})
			// this.$store.commit(TYPES.SET_EVENT_PROP, {prop: 'images', value: this.images.map((obj) => obj.pk)})
			// this.$store.commit(TYPES.SET_EVENT_PROP, {prop: 'imageObjs', value: this.images})
			this.setAddEventProp({
				prop: 'images',
				value: deepCloneArray(this.images.map(obj => obj.pk))
			})
			this.setAddEventProp({
				prop: 'imageObjs',
				value: deepCloneArray(this.images)
			})
		},
		uploadComplete(file, xhr, formData) {
			this.photosUploading = false
		},
		uploadStarted(file, xhr, formData) {
			this.photosUploading = true
		},
		uploadCancelled(file, xhr, formData) {
			console.log('upload cancelled')
		}
	},
	computed: {
		...mapGetters(['getAddEventImagesUrls', 'getAddEventProp']),
		primaryImage: {
			get() {
				return this.getAddEventProp('primaryImage')
			},
			set(val) {
				this.setAddEventProp({ prop: 'primaryImage', value: val })
			}
		},
		infoDialog: {
			get() {
				return this.getAddEventProp('infoDialog')
			},
			set(val) {
				this.setAddEventProp({ prop: 'infoDialog', value: val })
			}
		}
	},
	components: {
		vueDropzone: vue2Dropzone
	}
}
</script>

<style lang="scss">
</style>
